module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "notice-item"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.$emit('itemClicked')
      }
    }
  }, [_vm._v(_vm._s(_vm.name) + "\n        "), (_vm.isNew) ? _c('span', {
    staticClass: "notice-new"
  }, [_c('img', {
    attrs: {
      "src": "//awp-assets.meituan.net/hfe/fep/8998afcc22bad060d889bc2aee1766d5/newnotice.svg"
    }
  })]) : _vm._e()]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.date))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f90e302e","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homepage/noticeItem.vue
// module id = 746
// module chunks = 0